import {
  faBriefcase,
  faEnvelope,
  faHome,
  faMicrochip,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { useLocation } from 'react-router-dom'
import NavItem from './NavLink'

const NavBar = () => {
  const location = useLocation()
  const isOnExcludedRoutes =
    location.pathname === '/channel' || location.pathname === '/playground'
  return (
    <nav
      className="flex
    flex-col
    items-center
    text-center
    absolute
    top-1/2
    transform
    -translate-y-1/2
    w-full"
    >
      <NavItem to="/" icon={faHome} label="HOME" />
      <NavItem
        to="/portfolio"
        icon={faBriefcase}
        label="PORTFOLIO"
        afterTextSize="after:text-base"
        bottomOffset="after:bottom-8"
      />
      <NavItem to="/about" icon={faUser} label="ABOUT" />
      <NavItem
        to="/contact"
        icon={faEnvelope}
        label="CONTACT"
        afterTextSize="after:text-base"
        bottomOffset="after:bottom-7"
      />
      <NavItem
        to={!isOnExcludedRoutes ? '/playground' : location.pathname}
        icon={faMicrochip}
        label="PLAYGROUND"
        afterTextSize="after:text-xs"
        bottomOffset="after:bottom-8"
      />
    </nav>
  )
}

export default NavBar
